import { designVariables } from "@studio3t/design-variables";
import styled from "styled-components";
import { OverlayScroll } from "@/components/OverlayScroll";

const BUTTON = designVariables.ui.button;

// Leading provider icon inside the current breadcrumb crumb (Figma
// 13721-25259): the crumb is a medium button, so the icon sits a button gap
// from the label, not the breadcrumb item gap (that one spaces the crumb
// from its badge). Fixed-size so a long service name wrapping beside it
// doesn't squeeze the icon.
export const CrumbLeadingIcon = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: ${BUTTON.gap}px;
`;

export const Section = styled.section`
  margin-bottom: 20px;
`;

export const SectionTitle = styled.h2`
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: ${(props) => props.theme.semanticTextHeading};
`;

export const Card = styled.div`
  background: ${(props) => props.theme.cards1Background};
  border: 1px solid ${(props) => props.theme.cards1Border};
  border-radius: 6px;
  padding: 16px;
`;

export const ScriptCard = styled.div`
  background: ${(props) => props.theme.cards1Background};
  border: 1px solid ${(props) => props.theme.cards1Border};
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

// Standard Card/header (Figma 14064-11438): a 50px white row, spacingm
// horizontal padding, with the divider line to the content below.
export const ScriptHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 50px;
  padding: 0 ${designVariables.ui.semantic.spacingm}px;
  background: ${(props) => props.theme.cards1Background};
  border-bottom: 1px solid ${(props) => props.theme.cards1Border};
`;

// H6 title, per the Card/header component.
export const ScriptName = styled.span`
  font-size: ${designVariables.type.heading.h6.fontSize}px;
  font-weight: ${designVariables.type.heading.h6.fontWeight};
  color: ${(props) => props.theme.semanticTextHeading};
`;

// The full Raw-configuration chrome (line numbers, fold chevrons), capped so
// long scripts scroll past it on the app's scrollbars (same recipe as the
// pipeline detail's script cards): the editor grows to its content and the
// wrapper scrolls.
export const ScriptEditorWrapper = styled(OverlayScroll)`
  max-height: 300px;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px;
  color: ${(props) => props.theme.semanticTextDisabled};
`;

// Container for the page-level loading skeleton: spaces the placeholder
// blocks like the real header + sections stack.
export const PageSkeletonStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
